import { Directive } from 'vue';

export function decimalFormatter(value: number | string, maxDecimals: number = 4) {
   return value
      .toString()
      .replace(/,/g, '.') // Replace commas with dots
      .replace(/^-?|[^0-9.]/g, (match, offset) => (offset === 0 || match === '-' ? match : '')) // Remove invalid characters
      .replace(new RegExp(`(\\.[0-9]{${maxDecimals}})[0-9]*$`), '$1'); // Limit decimal places
}

export function parseDecimalField(value: unknown, maxDecimals: number = 4): number | undefined {
   if (value === undefined || value === null || value === '') return undefined;

   const cleaned = decimalFormatter(String(value), maxDecimals);
   if (cleaned === '' || cleaned === '-') return undefined;

   const parsed = Number(cleaned);
   return Number.isFinite(parsed) ? parsed : undefined;
}

export function normalizeDecimalFieldValue(value: unknown, maxDecimals: number = 4): number | string | undefined {
   if (value === undefined || value === null || value === '') return undefined;

   const cleaned = decimalFormatter(String(value), maxDecimals);
   if (cleaned === '' || cleaned === '-') return undefined;
   if (/\.(\d*0)?$/.test(cleaned)) return cleaned;

   const parsed = Number(cleaned);
   return Number.isFinite(parsed) ? parsed : cleaned;
}

export function decimalFormatterInput(el: HTMLElement, { value }: { value: number }) {
   const input = el.querySelector('input');
   const maxDecimals = value;

   if (!input) return;

   const cleanedValue = decimalFormatter(input.value, maxDecimals);

   input.value = cleanedValue;
}

const decimalFormatterDirective: Directive = {
   mounted: decimalFormatterInput,
   updated: decimalFormatterInput,
   deep: true,
};

export default decimalFormatterDirective;
